import { Component, OnInit } from '@angular/core';
import { Data2Service } from 'src/app/common/data2.service';

@Component({
	selector: 'app-transport-leads-list',
	templateUrl: './transport-leads-list.component.html',
	styleUrls: ['./transport-leads-list.component.css'],
})
export class TransportLeadsListComponent implements OnInit {
	private itemsBeforeDataLoad = 0;
	loader = false;
	data: Array<any> = [];
	tableRows = [
		{ id: 'name', name: 'Nazwa' },
		{ id: 'date_from', name: 'Data rozpoczęcia' },
		{ id: 'date_to', name: 'Data zakończenia' },
	];
	parameters = {
		vehicle: [],
		category: [],
		status: [],
		yesno: [],
		vehicle_type: [],
		vehicle_busType: [],
		vehicle_category: [],
		vehicle_status: [],
		users: [],
	};
	filters = {
		date_from: '2021-11-01',
		date_to: '2021-11-10',
	};

	constructor(private readonly api: Data2Service) {}

	ngOnInit(): void {
		this.loadData();
	}

	private loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.loader = true;
		let parms = this.api.getChecked(this.filters, this.parameters);
		parms += '&leads=1';
		this.api.get('/tourismEvents/?' + parms, (result, error) => {
			this.data = result.data;
			this.loader = false;
		});
	}

	filtersOpen() {
		// new TourismEventsFiltersComponent(this.api).filtersOpen();
	}

	filtersSelected(data) {
		// this.filters = data;
		// if (!this.filters.date_from) {
		// 	this.filters.date_from = this.date.daysAdd(-5);
		// }
		// if (!this.filters.date_to) {
		// 	this.filters.date_to = this.date.daysAdd(+5);
		// }
		// this.loadData();
	}
}
